import type { WizardFlowDefinition } from '@/modules/wizard/types/WizardFlowDefinition'

export const onboardingFlow: WizardFlowDefinition = {
  steps: [
    { id: 'welcome' },
    { id: 'hzb_select' },
    {
      id: 'hzb_document_upload',
      if: ['hasUniversityEntranceQualificationFromAbroad'],
    },
    {
      id: 'consultation_booking',
      if: ['isEebInOnboarding'],
      unless: ['hasUniversityEntranceQualificationFromAbroad'],
    },
    {
      id: 'language_proficiency_selection',
      if: ['hasUniversityEntranceQualificationFromAbroad'],
    },
    {
      id: 'language_certificate_upload',
      if: ['hasAbroadDiploma', 'hasSufficientGermanLanguageProficiency'],
    },
    {
      id: 'language_proficiency_insufficient',
      if: ['hasUniversityEntranceQualificationFromAbroad'],
      unless: ['hasSufficientGermanLanguageProficiency'],
    },
    {
      id: 'success',
      if: [
        'hasSufficientGermanLanguageProficiency',
        'hasUniversityEntranceQualificationFromAbroad',
      ],
    },
  ],
}
